/**
 * Runtime feature flags — fetched once at bootstrap from /api/feature-flags.
 * Flip in SQL (ops.FeatureFlags) to enable without redeploy.
 */

import { create } from 'zustand'

type FlagMap = Record<string, boolean>

interface FeatureFlagState {
  flags: FlagMap
  loaded: boolean
  load: () => Promise<void>
  isOn: (flag: string) => boolean
}

export const useFeatureFlagsStore = create<FeatureFlagState>((set, get) => ({
  flags: {},
  loaded: false,
  load: async () => {
    try {
      const res = await window.fetch('/api/feature-flags', { credentials: 'include' })
      if (res.ok) {
        const body = await res.json() as { flags?: FlagMap }
        set({ flags: body.flags ?? {}, loaded: true })
        return
      }
    } catch { /* ignore — leave flags empty so features remain OFF */ }
    set({ loaded: true })
  },
  isOn: (flag: string) => Boolean(get().flags[flag]),
}))
